export default __webpack_public_path__ + "static/media/email.1173a06c.svg";